import IconComponent from "icons/IconComponent";

import WebLinkIcon from "./web-link.svg";

export default (WebLinkIcon as any) as IconComponent;
